module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-nw.44e3708e.png";